module.exports = __webpack_public_path__ + "static/media/thumb_WMNQ6810_1024.5561b4aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_WMNQ6810_1024.jpg
// module id = 139
// module chunks = 0